
import { Component, Prop, Vue } from "vue-property-decorator";
import FinderVue from "@/finder/Finder.vue";
import  ButtonVue from "@/lib/Button.vue";
import { Next, Route } from 'vue-router';
import { IGroup } from "./IGroup"
import { Group } from "./Group"
import { GroupSvc } from "./GroupSvc";
import { Debouncer } from "@/lib/Debouncer";
import  ClipAddMultiVue from "@/clip/ClipAddMulti.vue";

 @Component({
        async beforeRouteEnter(to: Route, from: Route, next: Next<GroupsVue>) {
            const groups = await new GroupSvc().find_all()
            next((vm: GroupsVue) => {
              console.log(groups)
              if (groups) vm.groups = groups;
              else vm.groups=[]
            });
        },

      components: { FinderVue, ButtonVue,ClipAddMultiVue }
})
export default class GroupsVue extends Vue {

    filter:string="";
    groups: IGroup[]=[];
    key:number=1;
    debounced:any
 
    async mounted() {
      this.debounced = Debouncer.debounce(await (this._chg.bind(this)), 1000).bind(this);
    }

    async chg() {
    if (!this.debounced) return;
    await this.debounced();
  }

    async _chg() {

      let f={}
      if (this.filter) {
        const r = ".*" + this.filter + ".*";
        f = { $or: [ { idn: { $regex: r, $options: "i" }},{ contacts: { $regex: r, $options: "i" }} ] };
      } else {
        const r = ".*";
        f = { idn: { $regex: r, $options: "i" } };
      }
      this.groups = await new GroupSvc().find_by_filter(f)
      this.key++;
    }

    async save(group:IGroup) {
      group.contacts=group.contacts.toLowerCase()
      await new GroupSvc().save(group)
      this._chg()
    }

    async add_group() {

      const group = new Group()
      group.idn=this.filter.toUpperCase();
      const r=await new GroupSvc().save(group)
      if (r) {
        group.version=r.version;
        group._id=r._id;
        this.filter=""
      }
      this.chg(); 
    }

  async del_group(group:IGroup) {

      console.log(group._id)
      if (!group._id) alert("No group _id");
      
      if (group.contacts && group.contacts.length>0) {
        alert("Najpierw usuń wszystkie kontakty z tej grupy!");
        return;
      }
      
      const r=await new GroupSvc().del(group._id)

      if (r) {
        this.chg()
        alert ("Grupa została skasowana")
      }
    }

}

